module.exports = __webpack_public_path__ + "static/images/jf-tag-sgzs.1170ec7.png";